import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutEdiStopNote extends Layout {
    sourceEdiStopNote: DataSource;
    tableEdiStopNote: Table;
}
